export const treeCollectionsMapping = [
    {
      'title': 'All',
      'key': -9,
      'children': [
        {
          'title': 'Maps & Plans',
          'key': -1,
          'children': [
            {
              'title': 'Crown Plans',
              'key': 54,
              'children': [
                {
                  'title': '(31) Bridge Street Crown Plans',
                  'key': 31
                },
                {
                  'title': '(55) State Records Crown Plans',
                  'key': 55
                }
              ]
            },
            {
              'title': '(51) DP Mini Cards',
              'key': 51
            },
            {
              'title': '(66) Detailed Survey Sheet Index',
              'key': 66
            },
            {
              'title': '(36) Plan Lodgement Book',
              'key': 36
            },
            {
              'title': 'Historical Parish Maps',
              'key': 37,
              'children': [
                {
                  'title': '(41) County Maps',
                  'key': 41
                },
                {
                  'title': '(38) Parish Maps',
                  'key': 38
                },
                {
                  'title': '(40) Pastoral Maps',
                  'key': 40
                },
                {
                  'title': '(39) Town Maps',
                  'key': 39
                }
              ]
            },
            {
              'title': 'LTO Charting Maps',
              'key': 2,
              'children': [
                {
                  'title': '(11) Armstrong',
                  'key': 11
                },
                {
                  'title': '(12) CMA Sheet',
                  'key': 12
                },
                {
                  'title': '(14) City Section',
                  'key': 14
                },
                {
                  'title': '(3) County Map',
                  'key': 3
                },
                {
                  'title': '(15) Cumberland County Council Sheet',
                  'key': 15
                },
                {
                  'title': '(16) Deposited Plan',
                  'key': 16
                },
                {
                  'title': '(6) Estate Plan',
                  'key': 6
                },
                {
                  'title': '(9) Litho',
                  'key': 9
                },
                {
                  'title': '(10) Norton',
                  'key': 10
                },
                {
                  'title': '(4) Parish Map',
                  'key': 4
                },
                {
                  'title': '(13) Roll Plan',
                  'key': 13
                },
                {
                  'title': '(5) Town Map',
                  'key': 5
                },
                {
                  'title': '(7) VG Sheet',
                  'key': 7
                },
                {
                  'title': '(8) Wells',
                  'key': 8
                }
              ]
            },
            {
              'title': 'Regional Charting Maps',
              'key': 22,
              'children': [
                {
                  'title': '(28) Administrative Map',
                  'key': 28
                },
                {
                  'title': '(23) County Map',
                  'key': 23
                },
                {
                  'title': '(26) Environs Map',
                  'key': 26
                },
                {
                  'title': '(29) Irrigation Map',
                  'key': 29
                },
                {
                  'title': '(24) Parish Map',
                  'key': 24
                },
                {
                  'title': '(27) Pasturage Map',
                  'key': 27
                },
                {
                  'title': '(25) Town Map',
                  'key': 25
                }
              ]
            },
            {
              'title': 'Status Branch Charting Maps',
              'key': 17,
              'children': [
                {
                  'title': '(18) County Map',
                  'key': 18
                },
                {
                  'title': '(21) Environs Map',
                  'key': 21
                },
                {
                  'title': '(32) Irrigation Map',
                  'key': 32
                },
                {
                  'title': '(19) Parish Map',
                  'key': 19
                },
                {
                  'title': '(33) Pasturage Map',
                  'key': 33
                },
                {
                  'title': '(20) Town Map',
                  'key': 20
                }
              ]
            }
          ]
        },
        {
          'title': 'Old System Records',
          'key': 52,
          'children': [
            {
              'title': 'Miscellaneous Old System Records',
              'key': -2,
              'children': [
                {
                  'title': '(43) Anglican Primates',
                  'key': 43
                },
                {
                  'title': '(44) First Land Grant',
                  'key': 44
                },
                {
                  'title': '(45) Governors',
                  'key': 45
                },
                {
                  'title': '(48) Newspaper Article',
                  'key': 48
                },
                {
                  'title': '(49) Settlements in NSW',
                  'key': 49
                }
              ]
            },
            {
              'title': 'Old System Indexes',
              'key': 34,
              'children': [
                {
                  'title': '(68) Conditional Purchase Index',
                  'key': 68
                },
                {
                  'title': '(67) Change of Name Index 1875-1967',
                  'key': 67
                },
                {
                  'title': '(69) Deposited Deeds Index',
                  'key': 69
                },
                {
                  'title': '(70) Deposited Deeds Receipt Books',
                  'key': 70
                },
                {
                  'title': '(62) Grant Register Index of Pardons',
                  'key': 62
                },
                {
                  'title': '(60) Grant Register Supplementary Index',
                  'key': 60
                },
                {
                  'title': '(75) Miscellaneous Register Index',
                  'key': 75
                },
                {
                  'title': 'Old System Grant Indexes',
                  'key': -3,
                  'children': [
                    {
                      'title': '(42) Grant Index',
                      'key': 42
                    },
                    {
                      'title': '(46) Index Deeds Grant Issued of Town Allotments',
                      'key': 46
                    },
                    {
                      'title': '(47) Index of Land Purchase Forms 1860-1862',
                      'key': 47
                    },
                    {
                      'title': '(50) Town Grants and Purchases',
                      'key': 50
                    }
                  ]
                },
                {
                  'title': '(57) Purchasers Index',
                  'key': 57
                },
                {
                  'title': '(35) St Mary MacKillop Deeds',
                  'key': 35
                },
                {
                  'title': '(56) Vendors Index',
                  'key': 56
                },
                {
                  'title': '(65) Vendors Index (only Mac Mc)',
                  'key': 65
                }
              ]
            },
            {
              'title': 'Old System Registers',
              'key': -4,
              'children': [
                {
                  'title': '(64) General Register of Deeds (Old System Deeds)',
                  'key': 64
                },
                {
                  'title': '(61) Grant Register',
                  'key': 61
                },
                {
                  'title': '(63) Grant Register of Pardons',
                  'key': 63
                },
                {
                  'title': '(74) Miscellaneous Register',
                  'key': 74
                }
              ]
            },
            {
              'title': 'Primary Applications',
              'key': -6,
              'children': [
                {
                  'title': '(72) Primary Application Search Books',
                  'key': 72
                },
                {
                  'title': '(73) Primary Application Miscellaneous Search Books',
                  'key': 73
                },
                {
                  'title': '(71) Primary Application Search Sketches',
                  'key': 71
                }
              ]
            }
          ]
        },
        {
          'title': 'Torrens Records',
          'key': -10,
          'children': [
            {
              'title': '(30) Old Form Torrens Register',
              'key': 30
            },
            {
              'title': '(58) Torrens Purchasers Index 1863-1971',
              'key': 58
            }
          ]
        }
      ]
    }
  ]
;



// WEBPACK FOOTER //
// ./src/treemappings.ts